import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import StaffShell from "../components/StaffShell";
import { api } from "../lib/api";

const STATUSES = ["", "checked_in", "diagnosing", "awaiting_approval", "awaiting_parts", "in_progress", "ready_for_pickup", "closed", "cancelled"];

export default function TicketsList() {
  const [tickets, setTickets] = useState(null);
  const [query, setQuery] = useState("");
  const [status, setStatus] = useState("");
  const [payment, setPayment] = useState("");

  useEffect(() => {
    const q = new URLSearchParams();
    if (query) q.set("query", query);
    if (status) q.set("status", status);
    if (payment) q.set("payment", payment);
    const t = window.setTimeout(() => {
      api(`/staff/tickets?${q.toString()}`).then((d) => setTickets(d.tickets)).catch(() => {});
    }, query ? 300 : 0);
    return () => window.clearTimeout(t);
  }, [query, status, payment]);

  return (
    <StaffShell title="Tickets">
      <div className="toolbar" data-testid="tickets-toolbar">
        <input placeholder="Search number, name, phone, vehicle, VIN, concern…" value={query}
          onChange={(e) => setQuery(e.target.value)} style={{ minWidth: 300 }} data-testid="tickets-search-input" />
        <select value={status} onChange={(e) => setStatus(e.target.value)} data-testid="tickets-status-filter">
          {STATUSES.map((s) => <option key={s} value={s}>{s ? s.replace(/_/g, " ") : "All statuses"}</option>)}
        </select>
        <select value={payment} onChange={(e) => setPayment(e.target.value)} data-testid="tickets-payment-filter">
          <option value="">Any payment state</option>
          <option value="paid">Paid</option>
          <option value="unpaid">Unpaid</option>
        </select>
      </div>

      {tickets === null && <div className="skeleton" style={{ height: 200 }} />}
      {tickets && tickets.length === 0 && (
        <div className="card muted" style={{ padding: 30, textAlign: "center" }}>
          No tickets match. Create one from <Link to="/intake" style={{ color: "var(--blue-bright)" }}>Check-In</Link>.
        </div>
      )}

      {tickets && tickets.length > 0 && (
        <div className="card" style={{ overflowX: "auto" }}>
          <table className="data" data-testid="tickets-table">
            <thead>
              <tr><th>Ticket</th><th>Customer</th><th>Vehicle</th><th>Status</th><th>Priority</th><th>Payment</th><th></th></tr>
            </thead>
            <tbody>
              {tickets.map((t) => (
                <tr key={t.id} data-testid={`ticket-row-${t.number}`}>
                  <td><strong className="mono">{t.number}</strong><br /><span className="muted mono" style={{ fontSize: 11 }}>{(t.created_at || "").slice(0, 10)}</span></td>
                  <td>{t.customer.first_name} {t.customer.last_name}<br /><span className="muted" style={{ fontSize: 12 }}>{t.customer.phone}</span></td>
                  <td>{t.vehicle.year} {t.vehicle.make} {t.vehicle.model}{t.vehicle.vin ? <><br /><span className="mono muted" style={{ fontSize: 11 }}>{t.vehicle.vin}</span></> : null}</td>
                  <td><span className={`pill ${t.status}`}>{t.status.replace(/_/g, " ")}</span></td>
                  <td className="muted">{t.priority}</td>
                  <td><span className={`pill ${t.payment?.paid ? "paid" : ""}`}>{t.payment?.paid ? "paid" : "unpaid"}</span></td>
                  <td><Link className="btn btn-ghost btn-sm" to={`/tickets/${t.id}`} data-testid={`ticket-open-${t.number}`}>Open</Link></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </StaffShell>
  );
}
